<template>
  <div class="app_box">
    <router-view></router-view>
  </div>
</template>

<script>
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  display: block;
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
}
body {
  font-family: -apple-system, Noto Sans, Helvetica Neue, Helvetica,
    Nimbus Sans L, Arial, Liberation Sans, PingFang SC, Hiragino Sans GB,
    Noto Sans CJK SC, Source Han Sans SC, Source Han Sans CN, Microsoft YaHei,
    Wenquanyi Micro Hei, WenQuanYi Zen Hei, ST Heiti, SimHei,
    WenQuanYi Zen Hei Sharp, sans-serif;
  color: #fff;
  font-size: 14px;
}
</style>
